var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.26562 17.375C6.875 16.9062 7.67188 16.8125 8.375 17.0469C9.59375 17.5156 11 17.75 12.5 17.75C18.3125 17.75 22.25 14 22.25 10.25C22.25 6.54688 18.3125 2.75 12.5 2.75C6.64062 2.75 2.75 6.54688 2.75 10.25C2.75 11.75 3.3125 13.2031 4.39062 14.4688C4.8125 14.8906 5 15.5 4.95312 16.1094C4.90625 16.9531 4.67188 17.75 4.4375 18.4531C5.23438 18.0781 5.89062 17.6562 6.26562 17.375ZM1.48438 19.25C1.57812 19.1562 1.625 19.0156 1.71875 18.875C2.1875 18.125 2.60938 17.0938 2.70312 15.9219C1.29688 14.3281 0.5 12.4062 0.5 10.25C0.5 4.90625 5.84375 0.5 12.5 0.5C19.1094 0.5 24.5 4.90625 24.5 10.25C24.5 15.6406 19.1094 20 12.5 20C10.7188 20 9.07812 19.7188 7.57812 19.2031C7.0625 19.5781 6.125 20.1406 5.04688 20.6094C4.34375 20.9375 3.54688 21.2188 2.70312 21.3594C2.65625 21.3594 2.60938 21.4062 2.60938 21.4062C2.375 21.4531 2.1875 21.4531 1.95312 21.5C1.71875 21.5 1.48438 21.5469 1.20312 21.5469C0.921875 21.5469 0.640625 21.3594 0.546875 21.0781C0.40625 20.7969 0.5 20.4688 0.6875 20.2344C0.875 20.0469 1.0625 19.8594 1.20312 19.625C1.29688 19.4844 1.39062 19.3906 1.4375 19.2969C1.4375 19.2969 1.4375 19.2969 1.4375 19.25H1.48438Z",
    fill: "#006D5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.c0713d524e56b69c3fb666495a0c82a6.svg";
export { ForwardRef as ReactComponent };